// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit-btn{margin:10px;padding:15px 60px;text-align:center;text-transform:uppercase;background-size:200% auto;display:block}.submit-btn,.submit-btn:hover{-webkit-transition:.7s!important;transition:.7s!important}.submit-btn:hover{background-position:100%;color:#fff!important;text-decoration:none!important;border:none;-webkit-box-shadow:0 0 30px #eee;box-shadow:0 0 30px #eee}", ""]);
// Exports
module.exports = exports;
